var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card, Icon } from '@material-ui/core';
import { CardTitle, ConfigFieldControl, ConfigTextField, IconPicker } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import ComponentRenderer from '../renderers/ComponentRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
export const SiteCard = props => {
    var _a;
    const { children } = props, componentProps = __rest(props, ["children"]);
    const component = useSubscribeComponentChanges(SiteCardPlugin, props);
    const { icon, title = 'Untitled' } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-card'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteCardPlugin }, componentProps),
        React.createElement(Card, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            (icon || title) && (React.createElement(CardTitle, null,
                icon && React.createElement(Icon, { className: 'icon' }, icon),
                title)), (_a = component.children) === null || _a === void 0 ? void 0 :
            _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child }))),
            children)));
};
export const SiteCardConfigurator = props => {
    var _a, _b;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(IconPicker, { value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.icon) || '', onChange: icon => {
                    update('props.icon', icon);
                } }),
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Title', value: ((_b = component.props) === null || _b === void 0 ? void 0 : _b.title) || '', onChange: event => {
                    update('props.title', event.target.value);
                } })),
        React.createElement(SiteComponentStackConfigurator, { component: props.component })));
};
export const SiteCardPlugin = {
    name: 'Card',
    type: 'card',
    slots: [
        {
            name: 'Card Content',
            type: 'component-stack',
            slot: 'card-content'
        }
    ],
    component: SiteCard,
    configurator: SiteCardConfigurator
};
//# sourceMappingURL=SiteCardPlugin.js.map